module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/hero_desktop-3cb0bf5c4aec4926f88c383279b65907.webp";